export const normalizeVersion = (value: string) => {
  if (!value) {
    return '';
  }
  const clean = value.split('-')[0];
  const parts = clean
    .split('.')
    .map((part) => part.replace(/[^0-9]/g, ''))
    .filter((part) => part.length > 0);
  if (parts.length === 0) {
    return '';
  }
  const padded = parts.map((part) => part.padStart(3, '0'));
  while (padded.length < 3) {
    padded.push('000');
  }
  return padded.slice(0, 3).join('.');
};
